<template>
   <v-list
      dense
      nav
   >
      <v-list-item

         link
         :to="{ name: 'EmployeeInterviewsDashboard'}"
         active-class="primary--text"
         exact
      >
         <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
         </v-list-item-icon>

         <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
         </v-list-item-content>
      </v-list-item>

      <v-list-group
         v-if="$can('show interview employee') || $can('show interview')"
         prepend-icon="mdi-forum"
         no-action
         :value="active"
      >
         <template v-slot:activator>
            <v-list-item-title>Gespräche</v-list-item-title>
         </template>
         <v-list-item
            link
            active-class="primary--text"
            exact
            :to="{ name: 'EmployeeInterviewsIndex'}"
         >


            <v-list-item-content>
               <v-list-item-title>Übersicht</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
               <v-icon>mdi-forum-outline</v-icon>
            </v-list-item-action>
         </v-list-item>

         <v-list-item
            v-if="$can('show employee')"
            link
            active-class="primary--text"
            exact
            :to="{ name: 'EmployeeInterviewsEmployees'}"
         >


            <v-list-item-content>
               <v-list-item-title>Mitarbeiter</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
               <v-icon>mdi-account-group-outline</v-icon>
            </v-list-item-action>
         </v-list-item>


         <v-list-item
            v-if="$can('create interview employee')"
            link
            active-class="primary--text"
            exact
            :to="{ name: 'EmployeeInterviewsCreate'}"
         >


            <v-list-item-content>
               <v-list-item-title class="primary--text">Neu</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
               <v-icon>mdi-plus</v-icon>
            </v-list-item-action>
         </v-list-item>

      </v-list-group>

      <v-list-item
         v-if="$can(['show interview own'])"
         link
         active-class="primary--text"
         exact
         :to="{ name: 'EmployeeInterviewsOwn'}"

      >
         <v-list-item-icon>
            <v-icon>mdi-message-text</v-icon>
         </v-list-item-icon>

         <v-list-item-content>
            <v-list-item-title>Eigene Gespräche</v-list-item-title>
         </v-list-item-content>
      </v-list-item>


      <!--Auswertungen-->

      <v-list-group
         v-if="$can('perform export') || $can('show analysis')"
         prepend-icon="mdi-chart-timeline-variant"
         no-action
         :value="activeAnalysis"
      >
         <template v-slot:activator>
            <v-list-item-title>Auswertungen</v-list-item-title>
         </template>

         <v-list-item
            link
            active-class="primary--text"
            exact
            :to="{ name: 'EmployeeInterviewsAnalysisDashboard'}"
         >
            <v-list-item-content>
               <v-list-item-title>Übersicht</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
               <v-icon>mdi-view-dashboard-outline</v-icon>
            </v-list-item-action>
         </v-list-item>

         <v-list-item
            v-if="$can('perform export')"
            link
            active-class="primary--text"
            exact
            :to="{ name: 'EmployeeInterviewsAnalysisExport'}"
         >
            <v-list-item-content>
               <v-list-item-title>Export</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
               <v-icon>mdi-download</v-icon>
            </v-list-item-action>
         </v-list-item>
      </v-list-group>
   </v-list>
</template>

<script>
export default {
   computed: {
      active() {
         return [
            'EmployeeInterviewsIndex',
            'EmployeeInterviewsEmployees',
            'EmployeeInterviewsCreate',
            'EmployeeInterviewsEdit'
         ].includes(this.$route.name);
      },
      activeAnalysis() {
         return [
            'EmployeeInterviewsExport',
         ].includes(this.$route.name);
      }
   },
}
</script>

<style scoped>

</style>
